import { $ } from './dom';

/** Polite screen-reader announcement (re-announces identical text by clearing first). */
export function announce(msg: string) {
  const el = $('#announcer');
  el.textContent = '';
  setTimeout(() => (el.textContent = msg), 60);
}
